import dynamicGrid from "flow/wrappers/dynamicGrid";
import register from "flow/knockout/register";

register.registerKnockoutBinding("dynamicGrid", {
    init: function (element, valueAccessor) {
        const handle = valueAccessor();

        handle(dynamicGrid.createWrapper(element));
    }
});
